import React from 'react'
import './_spinner.scss'

function Spinner() {
  return (
    <div data-testid="spinner" className="spinner" />
  )
}

Spinner.propTypes = {}

export default Spinner
